import styles from './style.module.scss';
import { Copy } from '../copy/copy';
import { IconWithLabel } from '../iconWithLabel/iconWithLabel';
import { isDesktop } from '../../helpers/viewports';
import { Button } from '../button/button';
import { useState } from 'react';
import { PositionList } from '../../helpers/apiService';
import { DropDown } from '../dropdown/dropdown';
import { CheckBox } from '../checkbox/checkbox';

const filterValues = [
	{
		searchCriteria: 'JobCategory',
		mappingName: 'categoryList',
	},
	{
		searchCriteria: 'CareerLevel',
		mappingName: 'careerLevelList',
	},
	{
		searchCriteria: 'PositionLocation',
		mappingName: 'locationList',
	},
];

export interface Filter {
	JobCategory?: string[];
	CareerLevel?: string[];
	PositionLocation?: string[];
	PositionSchedule?: string[];
}

interface IProps {
	filters: Filter;
	allEntries: PositionList | null;
	entries: PositionList | null;
	setDropdown: (filterName: string, filterValue?: string, isFilter?: boolean) => void;
	scrollRef: React.MutableRefObject<any>;
}

export function FilterMenu({ filters, setDropdown, entries, allEntries, scrollRef }: IProps) {
	const { labels } = window;
	const desktop = isDesktop();
	const [filterMenuOpen, setFilterMenuOpen] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(-1);

	const locationList: string[] = [];
	const careerLevelList: string[] = [];
	const categoryList: string[] = [];
	const scheduleList: string[] = [];

	if (allEntries) {
		allEntries.SearchResult.SearchResultItems.forEach((entry) => {
			const { PositionLocation, CareerLevel, JobCategory, PositionSchedule } = entry.MatchedObjectDescriptor;
			if (!locationList.find((cityname) => cityname === PositionLocation[0].CityName)) {
				locationList.push(PositionLocation[0].CityName);
			}
			if (!careerLevelList.find((level) => level === CareerLevel[0].Name)) {
				careerLevelList.push(CareerLevel[0].Name);
			}
			if (!categoryList.find((jobCategory) => jobCategory === JobCategory[0].Name)) {
				categoryList.push(JobCategory[0].Name);
			}
			if (PositionSchedule?.length && !scheduleList.find((schedule) => schedule === PositionSchedule[0].Name)) {
				scheduleList.push(PositionSchedule[0].Name);
			}
		});
	}

	let amountOfActiveFilters = 0;
	Object.values(filters).forEach((filter) => {
		amountOfActiveFilters += filter.length;
	});

	const dropdowns = {
		locationList,
		careerLevelList,
		categoryList,
	};

	function setFilterMenuState(bool) {
		// apply filter
		setFilterMenuOpen(bool);
		// scroll to Title Element when filter applied
		if (!bool){
			scrollRef.current.scrollIntoView();
		}
	}

	return filterMenuOpen || desktop ? (
		<div className={`${styles.filterWrapper} ${filterMenuOpen && !desktop ? styles.openMenu : ''}`}>
			<div className={`${styles.content} container clr__bg--white`}>
				{!desktop && (
					<Button
						className={styles.closeButton}
						withIcon
						onClick={() => setFilterMenuState(false)}
						useGlobalStyling={false}
					>
						<IconWithLabel tag="h4" className={styles.closeButtonText}>
							{labels['filter.openMenu']}
						</IconWithLabel>
					</Button>
				)}
				{filterValues.map(({ searchCriteria, mappingName }, index) => (
					<DropDown
						key={index}
						className={styles.dropdown}
						options={dropdowns[mappingName]}
						setActiveOption={setDropdown}
						filterCategoryName={searchCriteria}
						isOpen={currentIndex === index}
						currentIndex={index}
						setIsOpen={setCurrentIndex}
						currentOption={filters[searchCriteria]}
						placeHolder={
							labels[
								`filter.${
									searchCriteria.charAt(0).toLocaleLowerCase() + searchCriteria.substring(1)
								}`
							]
						}
					/>
				))}
				<div className={styles.checkboxesContainer}>
					<CheckBox
						label={labels['filter.fullTime']}
						onChange={setDropdown}
						checked={Boolean(
							filters.PositionSchedule?.find((schedule) => schedule === labels['filter.fullTime'])
						)}
					/>
					<CheckBox
						label={labels['filter.partTime']}
						onChange={setDropdown}
						checked={Boolean(
							filters.PositionSchedule?.find((schedule) => schedule === labels['filter.partTime'])
						)}
					/>
				</div>
				{!desktop && (
					<Button
						className={`${styles.filterButton} ${styles.showResultButton}`}
						withIcon
						onClick={() => setFilterMenuState(false)}
					>
						<Copy
							className={styles.copyBold}
							text={labels['filter.showResults'].replace(
								'#{count}',
								String(entries?.SearchResult.SearchResultCountAll)
							)}
						/>
					</Button>
				)}
			</div>
		</div>
	) : (
		<Button className={styles.filterButton} withIcon onClick={() => setFilterMenuState(true)}>
			<IconWithLabel tag={'div'} className={`${styles.buttonWithIcon} ${styles.filterTextWrapper}`}>
				<Copy className={styles.filterText} text={labels['filter.openMenu']} />
				<div className={styles.activeFilter}>{amountOfActiveFilters}</div>
			</IconWithLabel>
		</Button>
	);
}
